import { usePapersCount } from "@/hooks/usePapersCount";

interface Props {
  conceptId: string;
}

export function ClusterOverview({ conceptId }: Props) {
  const { data: counts } = usePapersCount(conceptId);

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Paper Overview</h3>

      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Seeds</span>
          <span className="font-medium">{counts?.foundational ?? 0}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Trawled</span>
          <span className="font-medium">{counts?.trawled ?? 0}</span>
        </div>
        {(counts?.scored ?? 0) > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Scored</span>
            <span className="font-medium">{counts?.scored}</span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-muted-foreground">With PDFs</span>
          <span className="font-medium">{counts?.with_pdfs ?? 0}</span>
        </div>
      </div>
    </div>
  );
}
